var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMoonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nightlight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4792 3.16659C11.7483 3.16659 12.0175 3.18242 12.2788 3.222C10.7667 4.932 9.89583 7.1645 9.89583 9.49992C9.89583 11.8353 10.7667 14.0678 12.2788 15.7778C12.0175 15.8174 11.7483 15.8333 11.4792 15.8333C7.98792 15.8333 5.14583 12.9912 5.14583 9.49992C5.14583 6.00867 7.98792 3.16659 11.4792 3.16659ZM11.4792 1.58325C7.10917 1.58325 3.5625 5.12992 3.5625 9.49992C3.5625 13.8699 7.10917 17.4166 11.4792 17.4166C12.92 17.4166 14.2738 17.0208 15.4375 16.3478C13.0704 14.9783 11.4792 12.4291 11.4792 9.49992C11.4792 6.57075 13.0704 4.02158 15.4375 2.652C14.2738 1.97909 12.92 1.58325 11.4792 1.58325Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoonBlack);
export default __webpack_public_path__ + "static/media/icon-moon-black.bfe5b5f5b853a17a7f6a9aa9520e7036.svg";
export { ForwardRef as ReactComponent };